<template>
  <!-- 限时抢购 -->
  <div class="homepage-recommand-cruises" v-if="cruiseCategories.length > 0">
    <h2 class="title">限时抢购</h2>
    <ul class="cruise-nav ul-nav">
      <li
        v-for="(category, index) in cruiseCategories"
        :key="index"
        :class="{ active: index == currentIndex }"
        :data-categoryid="category.Id"
        @click="onCategoryClick(index)"
      >
        {{ category.name }}
      </li>
    </ul>

    <ul
      class="cruise-content"
      v-for="(category, index) in cruiseCategories"
      :key="index"
      :class="{ active: index == currentIndex }"
    >
      <li
        v-for="(item, index) in getCruiseItems(category.id)"
        :key="index"
        class="cruise-link"
        @click="
          onCruiseClick(
            item.cruiseViewModel.shipCode,
            item.cruiseViewModel.sailDate,
            item.cruiseViewModel.isRow,
						index
          )
        "
        :data-cruisecategoryid="item.cruiseCategoryId"
      >
        <div class="cruise-image-content">
          <div class="img-tag" v-if="item.tag && item.tag.length > 0">
            <div class="tag-text">{{ item.tag }}</div>
          </div>
          <img
            class="heart inWishList"
            v-if="item.isInWishList"
            @click.stop="onWishListClick(item)"
            src="https://resource.rcclchina.com.cn/homePage/heart.png"
          />
          <img
            class="heart notInWishList"
            v-else
            @click.stop="onWishListClick(item)"
            src="https://resource.rcclchina.com.cn/homePage/nullHeart.png"
          />

          <div class="cruise-img">
            <img
              class="cru-img1"
              style="width: 100%"
              :src="item.image"
              alt="Alternate Text"
            />
            <div class="cruise-img-line"></div>
            <img
              v-if="item.shipCoverImage && item.shipCoverImage.length > 0"
              class="cru-img2"
              style="width: 100%"
              :src="item.shipCoverImage"
              alt=""
            />
            <img v-else class="f-dn" />
            <div class="ship">
              {{ item.shipName }}
              <img
                id="selectMoreIcon"
                style="margin-left: 4px"
                src="https://resource.rcclchina.com.cn/tui2/list/icon-more-select-up.png"
              />
            </div>
          </div>
        </div>
        <div class="cruise-intro">
          <div class="cruise-title">
            <p class="text">
              {{ getCruiseName(item) }}
            </p>

            <p class="time">
              {{
                item.sailDateBegin + " - " + item.sailDateEnd
              }}&nbsp;&nbsp;&nbsp;&nbsp;{{ getRouteNight(item) }}
            </p>
          </div>
          <div class="cruise-booking-content" v-if="item.price <= 0">
            <p class="price">售罄</p>
          </div>
          <div class="cruise-booking-content" v-else>
            <p class="price">
              {{ item.isNrp ? "早订特惠价" : "限时优惠价" }}
              <span> <i>￥</i>{{ item.price.toFixed(0) }}</span
              >/人起
            </p>
            <p
              class="dataTime"
              data-timer="@timespan"
              v-if="isShowCountDown(item)"
            >
              <img
                src="https://resource.rcclchina.com.cn/homePage/time.png"
                alt=""
              />
              <CruiseCountDown :countDownNum="getCountDown(item)" />
              <a class="link order hasCountDown" href="javascript:;"
                >立即预订</a
              >
            </p>
            <p class="dataTime" v-else>
              <a class="link order" href="javascript:;">立即预订</a>
            </p>
          </div>
        </div>
      </li>
    </ul>
    <LoginModal
      v-if="isShowLoginPopup"
      :onLoginSuccessHandler="onLoginSuccessHandler"
      :isShow="isShowLoginPopup"
    />
  </div>
</template>


<script>
import _ from "lodash";
import { gioAdsTracking } from "@/utilities/tools";
const CruiseCountDown = () => import("@/components/Home/CruiseCountDown");
const LoginModal = () => import("@/components/User/LoginModal.vue");
import api from "@/api";
export default {
  name: "HomeRecommendCruise",
  components: {
    CruiseCountDown,
    LoginModal,
  },
  props: {
    cruiseCategories: {
      type: Array,
      default: () => {
        return [];
      },
    },
    promoCruiseItems: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      currentIndex: 0,
      isShowLoginPopup: false,
      loginCallback: null,
    };
  },
  methods: {
    getCruiseItems(categoryId) {
      let cruiseItems = this.promoCruiseItems.filter(
        (item) => item.cruiseCategoryId == categoryId && item.cruiseViewModel
      );
      cruiseItems = _.orderBy(cruiseItems, "sortNumber", "desc");
      if (cruiseItems.length > 3) {
        cruiseItems = _.slice(cruiseItems, 0, 3);
      }
      return cruiseItems;
    },
    onCruiseClick(shipCode, sailDate, isRow, index) {
      let date = sailDate.split("T")[0];
			let url = isRow ? `${process.env.VUE_APP_TUI_URL}/Cruise/CruiseDetail?sailDate=${sailDate}&shipCode=${shipCode}`
			: `${process.env.VUE_APP_BASE_URL}/Rccl.Cruise/CruiseDetail?sailDate=${sailDate}&shipCode=${shipCode}`;
			const eventObject = {
				"adsType": "ls",
				"lsCatOrder": this.currentIndex+1,
				"lsItmOrder": index+1,
				"desUrl": url
			}
			gioAdsTracking(eventObject);

      if (isRow) {
        location.href = `${process.env.VUE_APP_TUI_URL}/Cruise/CruiseDetail?shipCode=${shipCode}&sailDate=${date}`;
      } else {
        this.$router.push(
          `/Rccl.Cruise/CruiseDetail?shipCode=${shipCode}&sailDate=${date}`
        );
      }
    },
    getCruiseName(item) {
      let cruiseName = item.cruiseViewModel.cruiseRoute;
      if (cruiseName > 49) {
        cruiseName = cruiseName.substr(0, 49) + "..";
      }
      return cruiseName;
    },
    getRouteNight(item) {
      const sailDays = item.cruiseViewModel.sailDays;
      return `${sailDays}天${sailDays - 1}晚`;
    },
    isShowCountDown(item) {
      let now = new Date();
      const endTime = item.promoEndTime;
      const moreDate = now.setTime(now.getTime() + 72 * 60 * 60 * 1000);
      let checkEndTime = 0;
      if (endTime && endTime.length > 0) {
        checkEndTime = new Date(endTime.replace("T", " ")).getTime();
        return item.isShowCountDown && checkEndTime < moreDate;
      }
      return false;
    },
    getCountDown(item) {
      const endTime = item.promoEndTime;
      let checkEndTime = 0;
      if (endTime && endTime.length > 0) {
        checkEndTime = new Date(endTime.replace("T", " ")).getTime();
      }
      return checkEndTime;
    },
    onCategoryClick(index) {
      this.currentIndex = index;
			const eventObject = {
				"adsType": "ls",
				"lsCatOrder": index+1
			}
			gioAdsTracking(eventObject);
    },
    onWishListClick(item) {
      if (item.isInWishList) {
        this.deleteWishList(item);
      } else {
        this.addWishList(item);
      }
    },
    showLoginPopup(callback) {
      this.isShowLoginPopup = true;
      this.loginCallback = callback;
    },
    onLoginSuccessHandler() {
      this.isShowLoginPopup = false;
      if (this.loginCallback) {
        this.loginCallback();
        this.loginCallback = null;
      }
    },
    async addWishList(item) {
      const userToken = this.$store.state.user.userToken;
      if (!userToken || userToken.length == 0) {
        const self = this;
        this.showLoginPopup(() => {
          self.addWishList(item);
        });
        return;
      }
      const requestData = {
        userName: userToken,
        cruiseId: item.cruiseViewModel.cruiseId,
        source: "PC",
      };
      this.$loading.show();
      const { success } = await api.cruise.addWishList(requestData);
      if (success) {
        item.isInWishList = true;
      }
      this.$loading.hide();
    },
    async deleteWishList(item) {
      const userToken = this.$store.state.user.userToken;
      if (!userToken || userToken.length == 0) {
        let self = this;
        this.$confirm.show("您尚未登录， 请登录之后， 再添加至心愿单", {
          confirmCallBack: () => {
            self.showLoginPopup(() => {
              self.deleteWishList();
            });
          },
        });
        return;
      }
      const requestData = {
        userName: userToken,
        cruiseId: item.cruiseViewModel.cruiseId,
        source: "PC",
      };
      this.$loading.show();
      const { success } = await api.cruise.deleteWishList(requestData);
      if (success) {
        item.isInWishList = false;
      }
      this.$loading.hide();
    },
  },
  computed: {},
};
</script>

<style scoped>
</style>